import api from '../../api/apiService';
import { Profile } from '../../models/Profile';
import { auth$ } from '../auth';
import { fetchProfile } from '../profile/profile.service';

const TRACK_URI = '/usage/v1/track';
let trackEvents: any[] = [];
let previousPathname: string | null = null;

interface TrackOption {
  key: string;
  value: string;
}

let userProfile: Profile | null = null;
auth$.subscribe(async (token) => {
  if (token) {
    userProfile = await fetchProfile();
    await trackPageView();
  }
});

const trackPageView = async (): Promise<void> => {
  if (location.pathname !== previousPathname) {
    previousPathname = location.pathname;
    await trackUsage('PAGE_VIEW', [
      {
        key: 'path',
        value: previousPathname,
      },
    ]);
  }
};

const callTrackUsageApi = async () => {
  if (userProfile && trackEvents.length > 0) {
    const array = trackEvents;
    trackEvents = [];
    await api.post(TRACK_URI, array);
  }
};

export const trackUrlChanges = (): void => {
  window.addEventListener('popstate', trackPageView);
  setInterval(callTrackUsageApi, 5000);
};

export const trackUsage = async (event: string, options?: TrackOption[]): Promise<void> => {
  if (userProfile) {
    trackEvents.push({
      event,
      user: userProfile.userId,
      staff: userProfile.staff,
      options,
      time: Date.now(),
    });
  }
};
